import React from "react";
import FetchApi from "../../../../customhooks/functionFetchApi"
import { statusflowall } from '../../../../form01/object-usestate/objectdefaults';
import {getProductbyjournal}from'./serviceproductcolor';
import{getcolor2}from'./serviceColor2';
import{getcolor6}from'./serviceColor6';
import{getcolor7}from'./serviceColor7';
import{getcolor8}from'./serviceColor8';

const FetchApis = new FetchApi();

export function createRevision_Duplicate(journalId) {

    // header 
    return FetchApis.FethcGet(`/journal/journalbyId/${journalId}`).then((res) => {
        if (res.data.status == 200) {
            createjournalHeader(res.data.data[0]);

        }
    })

}

export function saveNoterevise(datanote){
            return FetchApis.FethcPost(`/noterevise/createnoterevise`,datanote).then(res=>{
            }).catch(err => console.log(err))
    
}

// สร้าง journal
function createjournalHeader(data) {

    const usercode = sessionStorage.getItem('EmCode');

    return FetchApis.FethcGet(`/journal/createjournal-revision/${data.journalId}`).then((res) => {
     
        if (res.status == 200) {
           
            const newjourId = res.data.id;
            const jourId = data.journalId;

            selectjournallist(jourId, newjourId);
            updatestatus(newjourId);
            


        }
    })

async    function selectjournallist(jourid, newJourId) {

     await   FetchApis.FethcGet(`/journal/journalbyId/${jourid}`).then((res) => {
            if (res.status == 200) {
                getDatailjournal(jourid, newJourId, res.data.data[0].tdscode);
                getProductbyjournal(jourid, newJourId)
            }
        })
    }

    function updatestatus(journalid) {
        var stateflowall = {
            statusflow: statusflowall.newjournal,
            stateflow: "0"
        }
        // update state flow  new journal 
        FetchApis.FethcUpdate(`/journal/updatestateflow/${journalid}`, stateflowall).then((res) => { 
           
        })

    }

}


// เรียกข้อมูล ล่าสุดในการบันทึกเพื่อนำไปสร้างรายการ autonomust
 async function getDatailjournal(jourid, newJourId, TDScode) {
    // coating 
     FetchApis.FethcGet(`/coating/coatingByJournalId/${jourid}`).then((res) => {
        if (res.data.status == 200) {

            var datacoating = res.data.data;
            for (let index = 0; index < datacoating.length; index++) {
                const element = datacoating[index];
                createcoating(element, newJourId, TDScode)
            }
        }
    })
    // can & end forming
     FetchApis.FethcGet(`/forming/formingByJournalId/${jourid}`).then((res) => {
        if (res.data.status == 200) {
            createforming(res.data.data[0], newJourId, TDScode);
        }
    })
    // guideline for product pack
     FetchApis.FethcGet(`/guideline/guidelineByJournalId/${jourid}`).then((res) => {
        if (res.data.status == 200) {
            createguideline(res.data.data[0], newJourId, TDScode);
        }
    })
    // regulation
     FetchApis.FethcGet(`/regulation/regulationByJourId/${jourid}`).then((res) => {
        if (res.data.status == 200) {
            create_regulation(res.data.data[0], newJourId, TDScode);
        }
    }).catch(err => { console.log(err) })
    // Request sample
     FetchApis.FethcGet(`/requestsample/requestsampleByJournalId/${jourid}`).then((res) => {
        if (res.data.status == 200) {
            createrequest(res.data.data[0], newJourId, TDScode);
        }
    }).catch(err => { console.log(err) })

    //conponent code
     FetchApis.FethcGet(`/componentcode/componentByjournalId/${jourid}`).then((res) => {
        if (res.data.status == 200) {
            createComponente(res.data.data[0], newJourId, TDScode);
        }
    }).catch(err => { console.log(err) })

     FetchApis.FethcGet(`/specplanning/specplanningByJournalId/${jourid}`).then(res => {

        if (res) {
            var datalist=res.data.data;
            for (let index = 0; index < datalist.length; index++) {
                const dataspeclist = datalist[index];
                
                createSpecList(dataspeclist, newJourId, TDScode)
            }
        }
    }).catch(err => { console.log(err) })

    
      FetchApis.FethcGet(`/technical/techniaclByJournalId/${jourid}`).then(res=>{
            
            if(res){
                 var datalist=res.data.data;
                    for (let index = 0; index < datalist.length; index++) {
                        const datapartb = datalist[index];
                        createJournalPartB(datapartb,newJourId,TDScode);
                    }
                
    
            }
        }).catch(err => { console.log(err) });

        
         FetchApis.FethcGet(`/productionsystem/getproductByjournalid/${jourid}`).then(res=>{
             
                if(res){
                    var datalist=res.data.data;
                    for (let index = 0; index < datalist.length; index++) {
                        const DataList = datalist[index];
                            CreateProductsystem(DataList,newJourId, TDScode)
                    }
                }
            }).catch(err => { console.log(err) });
        

            FetchApis.FethcGet(`/packtest/getpacktestByjournalid/${jourid}`).then(res=>{
                if(res){
                     var datalist=res.data.data;
                     for (let index = 0; index < datalist.length; index++) {
                        const packateslist = datalist[index];
                            createPacktest(packateslist,newJourId)
                     }
                    
                }
            })


}

// สร้าง coating
function createcoating(data, journalId, newtdscode) {

    const { producttype, number, groupBobyType, substrate, shape, shapedetail, dia, ring_eartype,
        ring_earcode, forsaleorder, intcoating, intwhite, intother, extcoating,exttypewhite,extwhite, extother,
        note,fgcomponent,statusProof,tdscode } = data;

    var coatingdata = {
        producttype: producttype,
        number: number,
        groupBobyType: groupBobyType,
        substrate: substrate,
        shape: shape,
        shapedetail: shapedetail,
        dia: dia,
        ring_eartype: ring_eartype,
        ring_earcode: ring_earcode,
        forsaleorder: forsaleorder,
        intcoating: intcoating,
        intwhite: intwhite,
        intother: intother,
        extcoating: extcoating,
        exttypewhite:exttypewhite,
        extwhite: extwhite,
        extother: extother,
        note: note,
        fgcomponent:fgcomponent,
        statusProof:statusProof,
        journalId: journalId,
        tdscode: newtdscode
    }

    FetchApis.FethcPost(`/coating/createcoating`, coatingdata).then((res) => {
     
    }).catch(err => console.log(err))

}
//สร้าง can & end forming
function createforming(data, journalId, newtdscode) {
    const { internalside, internalother, seaming, seamingother, machineno, packaging, note, tdscode } = data;
    var formingdata = {
        internalside: internalside,
        internalother: internalother,
        seaming: seaming,
        seamingother: seamingother,
        machineno: machineno,
        packaging: packaging,
        note: note,
        journalId: journalId,
        tdscode: newtdscode
    }
    FetchApis.FethcPost(`/forming/createforming`, formingdata).then((res) => {
     
    }).catch(err => { console.log(err) })

}
// สร้าง guideline
function createguideline(data, journalId, newtdscode) {
    const {
        shelfyears,
        shelfdeg,
        typegroup,
        groupother,
        groupother_note,
        groupdryfood,
        groupaerosol,
        groupgeneral,
        detailproduct,
        ph,
        ingredients,
        ingredients_acid,
        ingredients_chioride,
        ingredientother,
        seamercondition,
        sterilization,
        sterilization_retort,
        sterilization_cooker,
        sterilizationother,
        // statusProof, 
        tdscode
    } = data;

    var dataguidelline = {
        shelfyears: shelfyears,
        shelfdeg: shelfdeg,
        typegroup: typegroup,
        groupother: groupother,
        groupother_note: groupother_note,
        groupdryfood: groupdryfood,
        groupaerosol: groupaerosol,
        groupgeneral: groupgeneral,
        detailproduct: detailproduct,
        ph: ph,
        ingredients: ingredients,
        ingredients_acid: ingredients_acid,
        ingredients_chioride: ingredients_chioride,
        ingredientother: ingredientother,
        seamercondition: seamercondition,
        sterilization: sterilization,
        sterilization_retort: sterilization_retort,
        sterilization_cooker: sterilization_cooker,
        sterilizationother: sterilizationother,
        // statusProof: statusProof,
        journalId: journalId,
        tdscode: newtdscode
    }

    FetchApis.FethcPost(`/guideline/createguideline`, dataguidelline).then((res) => {
     
    }).catch(err => { console.log(err) })

}
// สร้าง Request sample
function create_regulation(data, journalId, newtdscode) {

    const { regulationtype, regulationother, tdscode } = data;

    var dataregulation = {
        regulationtype: regulationtype,
        regulationother: regulationother,
        journalId: journalId,
        tdscode: newtdscode
    }

    FetchApis.FethcPost(`/regulation/createregulation`, dataregulation).then((res) => {
       
    }).catch(err => { console.log(err) });
}
//สร้าง Request sample
function createrequest(data, journalId, newtdscode) {
    const { proofplate, requestcan, requestend, requestnote, tdscode } = data;

    var datarequest = {
        proofplate: proofplate,
        requestcan: requestcan,
        requestend: requestend,
        requestnote: requestnote,
        journalId: journalId,
        tdscode: newtdscode
    }
    FetchApis.FethcPost(`/requestsample/createrequestsample`, datarequest).then((res) => {
    
        if (res.status == 200) {
         
        }
    }).catch(err => { console.log(err) })
}


//สร้าง componnet
function createComponente(data, newJournalId, newtdscode) {
    
    const { ear,earwelding,ring,innerlid, outerlid, toplid,bottomlid,plasticlid, aluminumlid, journalId, tdscode } = data;
   

    var datarequest = {
        ear: ear,
        earwelding:earwelding,
        ring:ring,
        innerlid: innerlid,
        outerlid: outerlid,
        toplid: toplid,
        bottomlid:bottomlid,
        plasticlid: plasticlid,
        aluminumlid: aluminumlid,
        journalId:newJournalId,
        tdscode:newtdscode
    }
    FetchApis.FethcPost(`/componentcode/createcomponentcode`, datarequest).then((res) => {
       
        if (res.status == 200) {
        }
    }).catch(err => { console.log(err) })
}

function createSpecList(dataspeclist, newJourId, newTDScode) {

    var DataSpec = {
        spectype: dataspeclist.spectype,
        sheetsize: dataspeclist.sheetsize,
        flatscroll: dataspeclist.flatscroll,
        straightscroll: dataspeclist.straightscroll,
        tin: dataspeclist.tin,
        temper: dataspeclist.temper,
        bright: dataspeclist.bright,
        row: dataspeclist.row,
        filmcode: dataspeclist.filmcode,
        refitemwc: dataspeclist.refitemwc,
        itemno: dataspeclist.itemno,
        journalId: newJourId,
        tdscode: newTDScode
    }

    FetchApis.FethcPost(`/specplanning/createspecplanning`, DataSpec).then(res => {
        if(res){
            // console.log(res);
        }
    })
}


function createJournalPartB(datalist,newjornalId,newTdscode){

    var DataAll={
        sequence:datalist.sequence,
            bodyside:datalist.bodyside,
            bodycolor:datalist.bodycolor,
            bodyfm:datalist.bodyfm,
            bodysolid:datalist.bodysolid,
            bodydfw_min:datalist.bodydfw_min,
            bodydfw_max:datalist.bodydfw_max,
            bodywfw:datalist.bodywfw,
            bodytemp:datalist.bodytemp,
            bodyspeed:datalist.bodyspeed,
            bodyrubber:datalist.bodyrubber,
                topside:datalist.topside,
                topcolor:datalist.topcolor,
                topfm:datalist.topfm,
                topsolid:datalist.topsolid,
                topdfw_min:datalist.topdfw_min,
                topdfw_max:datalist.topdfw_max,
                topwfw:datalist.topwfw,
                toptemp:datalist.toptemp,
                topspeed:datalist.topspeed,
                toprubber:datalist.toprubber,
                    bottomside:datalist.bottomside,
                    bottomcolor:datalist.bottomcolor,
                    bottomfm:datalist.bottomfm,
                    bottomsolid:datalist.bottomsolid,
                    bottomdfw_min:datalist.bottomdfw_min,
                    bottomdfw_max:datalist.bottomdfw_max,
                    bottomwfw:datalist.bottomwfw,
                    bottomtemp:datalist.bottomtemp,
                    bottomspeed:datalist.bottomspeed,
                    bottomrubber:datalist.bottomrubber,
                        rfFgbody:datalist.rfFgbody,
                        rfFgtop:datalist.rfFgtop,
                        rfFgbottom:datalist.rfFgbottom,
                            otherdetail:datalist.otherdetail,
                            journalId:newjornalId,
                            tdscode:newTdscode}
        FetchApis.FethcPost(`/technical/createtechnical`,DataAll).then(res=>{
            if(res){
              
                getcolor2(datalist.tecbid,res.tecId);
                getcolor6(datalist.tecbid,res.tecId);
                getcolor7(datalist.tecbid,res.tecId);
                getcolor8(datalist.tecbid,res.tecId);
            }
        })
} 

function CreateProductsystem(DataList, newJourId, newTDScode){
    var dataobjec={
            protype:DataList.protype,
            sideitemnumber:DataList.sideitemnumber,
            sidename:DataList.sidename,
            sidewfw:DataList.sidewfw,
            com1itemnumber:DataList.com1itemnumber,
            com1name:DataList.com1name,
            com1wfw:DataList.com1wfw,
            com2itemnumber:DataList.com2itemnumber,
            com2name:DataList.com2name,
            com2wfw:DataList.com2wfw,
            journalId:newJourId
    }

    FetchApis.FethcPost(`/productionsystem/creatproduc`,dataobjec).then(res=>{
        if(res){
            // console.log(res)
        }
    })
}

function createPacktest(DataList, newJourId) {
        var dataall={
            sidetinext:DataList.sidetinext, 
            sidetinint:DataList.sidetinint, 
            com1tinext:DataList.com1tinext,
            com1tinint:DataList.com1tinint, 
            com2tinext:DataList.com2tinext, 
            com2tinint:DataList.com2tinint,
            activebom:DataList.activebom, 
            auditdep:DataList.auditdep, 
            packtest:DataList.packtest,
            packer:DataList.packer, 
            refproduct:DataList.refproduct, 
            journalId:newJourId
        }

    FetchApis.FethcPost(`/packtest/createPacktest`,dataall).then(res=>{
        if(res){
            setTimeout(() => {
                window.location.reload()
            }, 1800);
        }
    })
}




